module.exports = __webpack_public_path__ + "static/media/advisor-1@3x.91adfa8a.jpg";